import React from 'react'
import { Icon, Popconfirm } from 'antd'

export default (props) =>
  <Popconfirm
    icon={<Icon type='question-circle-o' style={{ color: 'red' }} />}
    okType='danger'
    okText='ตกลง'
    cancelText='ยกเลิก'
    {...props} />



// WEBPACK FOOTER //
// ./src/components/CustomPopconfirm.js